export default __webpack_public_path__ + "static/media/extension-mobile-accounts.63a618b3.svg";